import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { IndexCoreMyideaApiService } from 'src/api/indexcore-myidea-api/indexcore-myidea-api.service'
export interface ActionTransactionSettings {
  enable: boolean // 出力オン・オフ切替（デフォルト＝無効）
  apiInfo: string // トランザクション登録エンドポイント情報
  data: any //アクションごとの設定
}
@Injectable({
  providedIn: 'root'
})
export class ActionTransactionService {
  constructor(private indexCoreMyideaApiService: IndexCoreMyideaApiService) {
    // サービス初期化時に設定を取得
    this.loadSettings()
  }
  
  private settings: ActionTransactionSettings | undefined //アクションCdごとの設定をセットする
  private settingsSubject = new BehaviorSubject<ActionTransactionSettings | undefined>(undefined)
  public settings$ = this.settingsSubject.asObservable()

  setSettings(settings: ActionTransactionSettings): void {
    this.settings = settings
    this.settingsSubject.next(settings)
  }
  
  getSettings() {
    return this.settings
  }

  // 設定を取得してセットする
  async loadSettings(): Promise<void> {
    try {
      const ret = await this.indexCoreMyideaApiService.getFrontendSettings('actions')
      if (ret) {
        const atSettings: ActionTransactionSettings = {
          enable: ret.data?.['myidea-basicSettings']?.enable,
          apiInfo: '', // Myideaでは使用しない
          data: ret.data
        }
        this.setSettings(atSettings)
      }
    } catch (error) {
      console.error('Failed to load action transaction settings:', error)
    }
  }

  // 外部から設定の再読み込みをトリガーできるメソッド
  async reloadSettings(): Promise<void> {
    await this.loadSettings()
  }
  //現在の出力設定が有効かどうかをチェック
  getActionTransactionSetting(commandCd: string) {
    let ret = false
    if (!(this.settings?.enable && this.settings?.data)) return ret
    let setting = this.settings.data[commandCd]
    if (setting) {
      if (setting.enable) {
        const currentDate = new Date()
        const start = new Date(setting.startAt)
        const end = new Date(setting.endAt)
        end.setDate(end.getDate() + 1) // endDate に 1 日足す
        if (currentDate >= start && currentDate < end) {
          ret = true
        }
      }
    }
    return ret
  }
  getCommandName(commandCd: string) {
    let ret = ''
    if (this.settings) {
      let setting = this.settings.data[commandCd]
      ret = setting?.name || ''
    }
    return ret
  }
}
